<template>
  <div v-if="hasData"
       class="btn btn-primary cta-download"
       @click="exportHandler">
    {{ label }}
  </div>
</template>

<script>

export default {
  name: "DownloadCsv",
  props: {
    label: {
      type: String,
      default: "Download"
    },
    fileName: {
      type: String,
      default: "csv-download"
    },
    inputData: {
      type: Array,
      default: () => []
    },
    blacklistKeys: {
      type: Array,
      default: () => []
    },
    tableId: {
      type: String,
      default: ""
    },
    formatKeys: {
      type: Array,
      default: () => []
      /*
        [
          { key: "totalCost", type: "currency" },
          { key: "orderedOn", type: "date" }
        ]
      */
    },
    delimiter: {
      type: String,
      default: ","
    }
  },
  computed: {
    exportDataFromTable () {
      return this.tableId !== "";
    },
    hasData () {
      return !( document.getElementById( this.tableId ) == null && this.inputData.length === 0 );
    }
  },
  methods: {
    exportHandler () {
      if ( this.exportDataFromTable ) {
        this.exportTableToCsv( this.tableId, this.delimiter );
      } else {
        this.exportDataToCsv( this.inputData, this.getWhiteListKeys(), this.delimiter );
      }
    },
    exportTableToCsv ( tableId, delimiter = "," ) {
      // select rows from tableId
      const rows = document.querySelectorAll( `table#${tableId} tr` );
      const csv = [];

      for ( let i = 0; i < rows.length; i += 1 ) {
        const row = [];
        const cols = rows[i].querySelectorAll( "td, th" );

        for ( let j = 0; j < cols.length; j += 1 ) {
          const value = cols[j].innerText;
          // clean innertext to remove multiple spaces and jumpline (break csv)
          let data = value.replace( /(\r\n|\n|\r)/gm, "" ).replace( /(\s\s)/gm, " " );
          // escape double-quote with double-double-quote
          data = data.replace( /"/g, `${null}""` );
          // push escaped string
          row.push( `"${data}"` );
        }

        csv.push( row.join( delimiter ) );
      }

      const csvStr = csv.join( "\n" );

      this.exportCsv( csvStr );
    },
    exportDataToCsv ( data, keys ) {
      const csvStr = this.convertDataToCsv( data, keys );
      this.exportCsv( csvStr );
    },
    exportCsv ( csvStr ) {
      const filename = `${this.fileName}.csv`;
      const universalBOM = "\uFEFF";
      const forceEncodedCsvString = `${universalBOM}${csvStr}`;
      const link = document.createElement( "a" );
      link.style.display = "none";
      link.setAttribute( "target", "_blank" );
      link.setAttribute( "href", `data:text/csv;charset=utf-16,${encodeURIComponent( forceEncodedCsvString )}` );
      link.setAttribute( "download", filename );
      document.body.appendChild( link );
      link.click();
      document.body.removeChild( link );
    },
    convertDataToCsv ( arr, columns, delimiter = "," ) {
      const cols = columns.map( col => this.camel2Title( col ) );
      return [
        cols.join( delimiter ),
        ...arr.map( obj => columns.reduce( ( acc, key ) => {
          const value = obj[key];

          let formattedValue;

          const { type } = this.formatKeys.find( format => format.key === key ) || {};

          switch ( type ) {
            case "currency":
              formattedValue = this.formatCurrency( value );
              break;
            case "date":
              formattedValue = this.formatDate( value );
              break;
            default:
              formattedValue = value ? `${value}` : "";
          }

          return `${acc}${!acc.length ? "" : delimiter}"${!formattedValue ? "" : formattedValue}"`;
        }, "" )
        )
      ].join( "\n" );
    },
    camel2Title ( camelCase ) {
      let result = null;
      const { name } = this.formatKeys.find( format => format.key === camelCase ) || {};
      if ( name ) {
        result = name;
      } else {
        result = camelCase
          .replace( /([A-Z])/g, ( match ) => ` ${match}` )
          .replace( /^./, ( match ) => match.toUpperCase() );
      }
      return result;
    },
    formatCurrency ( str ) {
      try {
        const formatter = new Intl.NumberFormat( "en-UK", {
          style: "currency",
          currency: "GBP",
          minimumFractionDigits: 2
        } );

        return formatter.format( str );
      } catch ( ex ) {
        console.warn( `Couldn't convert ${str} to a currency. Info: ${ex}` );
        return str;
      }
    },
    formatDate ( str ) {
      try {
        const date = new Date( str );

        const dateTimeFormat = new Intl.DateTimeFormat( "en", {
          year: "numeric",
          month: "short",
          day: "2-digit"
        } );

        const [{
          value: month
        }, , {
            value: day
          }, , {
            value: year
          }] = dateTimeFormat.formatToParts( date );

        return `${day}-${month}-${year}`;
      } catch ( ex ) {
        console.warn( `Couldn"t format ${str} to date. Info: ${ex}` );
        return str;
      }
    },
    getWhiteListKeys () {
      if ( this.inputData.length <= 0 ) {
        return [];
      }

      const index = this.inputData.length - 1;
      return Object.keys( this.inputData[index] )
        .filter( ( key ) => !this.blacklistKeys.includes( key ) );
    }
  }
};
</script>

<style lang="less" scoped>
  .cta-download {
    max-width: 200px;
    max-height: 36px;
    background-color: #007a7f;
    border: none;

    &:hover {
      background-color: #00383a;
    }
  }
</style>
